import InactiveRow from "./InactiveRow";
import InactiveCellRenderer from "../renderers/InactiveCellRenderer";
import UserGroupCellRenderer from "../renderers/UserGroupCellRenderer";

export default class UserGroupsSeparateRow extends InactiveRow {
    constructor(isFirstRow) {
        super();
        this.separateCellRenderer = new InactiveCellRenderer("userGroupsSeparatorLockCell");
        this.separateCellRenderer.getLastCellRightBorderClassName = function() { return "lockTableRightBorder"; };
        if (isFirstRow)
            this.groupCell.style.borderTop = "none";
    }

    createRowHeaderRenderer() {
        return new UserGroupCellRenderer("userGroupsSeparatorHeader");
    }

    createLockCellRenderer() {
        return this.separateCellRenderer;
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/rows/UserGroupsSeparateRow.js